<template>
  <div class="swpoll-userbar">
    <p>Hi, {{ this.authenticationMethods.passwordFree ? email : (name || 'Anonymous') }}</p>
<!--    <a v-if="view === 'poll' && leaderboardEnabled" @click="switchView('leaderboard')">-->
<!--      <span>Show Leaderboard</span>-->
<!--    </a>-->
    <a href="#" @click.prevent="logout()">Logout</a>
  </div>
</template>

<script>
import {
  mapState,
  mapActions
} from 'vuex';

export default {
  name: 'AuthHeader',
  props: {
  },
  computed: {
    ...mapState('voter', [
      'name',
      'email',
      'view',
      'authenticationMethods'
    ]),
    ...mapState('pollGroup', [
      'leaderboardEnabled',
    ])
  },
  methods: {
    ...mapActions('voter', [
      'switchView',
      'logout'
    ])
  }
}
</script>

<style scoped lang="scss">
 .swpoll-userbar {
   z-index: 10;
   display: flex;
   column-gap: 16px;
   justify-content: space-between;
   padding: 6px 8px;
   p {
     margin: 0;
     opacity: .5;
   }
   a {
     color: var(--text-color);
     opacity: .5;
     transition: .2s;
     text-decoration: underline;
     &:hover {
       opacity: 1;
       text-decoration: none;
     }
   }
 }
</style>
